function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { FilterIcon, Select } from '@hypothesis/frontend-shared';
import classnames from 'classnames';
import { Fragment } from 'preact';
import { moderationStatusInfo } from '../helpers';
import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
/**
 * A Select component displaying the list of moderation statuses.
 */
export default function ModerationStatusSelect(_ref) {
  var selected = _ref.selected,
    onChange = _ref.onChange,
    mode = _ref.mode,
    _ref$alignListbox = _ref.alignListbox,
    alignListbox = _ref$alignListbox === void 0 ? 'right' : _ref$alignListbox,
    disabled = _ref.disabled;
  var selectedName = selected ? moderationStatusInfo[selected].label : undefined;
  var SelectedIcon = selected ? moderationStatusInfo[selected].icon : Fragment;
  return _jsxs(Select, {
    value: selected
    // Cast to bypass TS warning that callback does not accept `undefined`.
    // We will only include `undefined` in the options if `mode == "filter"`
    // and this is allowed.
    ,
    onChange: onChange,
    alignListbox: alignListbox,
    containerClasses: "!w-auto",
    buttonClasses: classnames(mode === 'select' && {
      '!bg-green-light !text-green-dark': selected === 'APPROVED',
      '!bg-yellow-light !text-yellow-dark': selected === 'SPAM',
      '!bg-red-light !text-red-dark': selected === 'DENIED',
      // The styles above override default select disabled styles, so let's
      // add reduced opacity to those
      'disabled:opacity-50': selected !== 'PENDING'
    }),
    "aria-label": "Moderation status",
    buttonContent: _jsxs("div", {
      className: "flex gap-x-1.5 items-center",
      children: [mode === 'filter' ? _jsx(FilterIcon, {}) : _jsx(SelectedIcon, {}), selectedName !== null && selectedName !== void 0 ? selectedName : 'All']
    }),
    disabled: disabled,
    children: [mode === 'filter' && _jsx(Select.Option, {
      value: undefined,
      classes: "text-grey-7",
      children: "All"
    }), Object.entries(moderationStatusInfo).map(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        status = _ref3[0],
        _ref3$ = _ref3[1],
        label = _ref3$.label,
        Icon = _ref3$.icon;
      return _jsx(Select.Option, {
        value: status,
        children: _jsxs("div", {
          className: "flex gap-x-1.5 items-center text-grey-7",
          children: [_jsx(Icon, {}), label]
        })
      }, status);
    })]
  });
}
//# sourceMappingURL=ModerationStatusSelect.js.map